import React, { useEffect, useState } from 'react';
import { useCoverLetter } from '../../../context/CoverLetterContext';
import WpAPI from '../../../WpApi';
import JobForm from './JobForm';


const FinalJobDetailsForm = ({ data, save }) => {
    const [activeButton, setActiveButton] = useState(null);
    const [checkField, setCheckField] = useState('');
    const [loading, setLoading] = useState(false);
    const toggleActiveButton = (clicked) => {
        setActiveButton(data.job_details_provided)
        if (clicked) setActiveButton(clicked)
    }
    const fieldFocus = e => {
        setCheckField(e.target.name);
        // removeError(e);
    }
    const fieldBlur = e => {
        setCheckField('');
    }

    useEffect(() => {
        toggleActiveButton()
    })

    return (<div className="panel-body">
        <div className="screen-previous">
            {/* <h1>What job are you applying for?</h1> */}
            <div className="screen-block option-screen">
                <div
                    className={`choose-job-title purple-btn${data.job_details_provided === true ? ' active' : ''}`}
                    data-option="Yes"
                    onClick={(e) => {
                        toggleActiveButton(e.target.getAttribute('data-option'))
                        save({ job_details_provided: true })
                    }}>Yes</div>
                <div
                    className={`choose-job-title purple-btn${data.job_details_provided === false ? ' active' : ''}`}
                    data-option="Not Yet"
                    onClick={(e) => {
                        toggleActiveButton(e.target.getAttribute('data-option'))
                        save({ job_details_provided: false })
                    }}>Not Yet</div>
            </div>
            {data.job_details_provided == true && <div className="panel-yes-form"><JobForm data={data} save = {save} /></div>}
        </div>
    </div>)
}

export default FinalJobDetailsForm;